import React, { useState, useEffect } from "react";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import ProductDetailsOne from "../components/ProductDetailsOne";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import Breadcrumb from "../components/Breadcrumb";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import { useParams } from "react-router-dom";
import axios from "axios";
import NewArrivalOne from "../components/NewArrivalOne";
 


const ProductDetailsPageOne = () => {
  const { id } = useParams(); // Fetch parameter from the route
  const [data, setData] = useState(null);

  // Debug: Log id to verify it's being passed
  console.log("Fetched ID:", id);

  // Function to fetch data
  const fetchdata = () => {
    console.log("fetchdata called"); // Debug: Ensure function is called
    axios
      .get(`${process.env.REACT_APP_BACKEND_URI}/products/details/${id}`)
      .then((response) => {
        console.log("API Response:", response.data); // Debug: Check response data
        setData(response.data);
      })
      .catch((error) => {
        console.error("API Error:", error); // Debug: Log errors
      });
  };
 
  // useEffect to trigger fetchdata on component mount
  useEffect(() => {
    console.log("useEffect executed"); // Debug: Confirm useEffect execution
    fetchdata();
    
  }, [id]); // Add id as a dependency to ensure it updates if changed

  return (
    <>
      {/* Preloader */}
      <Preloader />

      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#299E60" />

      {/* HeaderOne */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb title={"Product Details"} />

      {/* ProductDetailsOne */}
      <ProductDetailsOne data={data} />

      {/* NewArrivalTwo */}
      <NewArrivalOne />

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default ProductDetailsPageOne;
